/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { HelpModalComponentArgs } from 'cio/components/help-modal';
import { isEmpty } from '@ember/utils';
import { inject as service } from '@ember/service';
import AnalyticsService from 'cio/services/analytics';

export default class VisualEditorFeedbackForm extends Component<HelpModalComponentArgs> {
  @service analytics!: AnalyticsService;

  @tracked suggestion = '';

  constructor(owner: unknown, args: HelpModalComponentArgs) {
    super(owner, args);

    this.analytics.track('user', 'feedback_request_started', {
      source: 'Visual Editor',
    });
  }

  get submitDisabled() {
    return isEmpty(this.suggestion);
  }

  get disabledTooltipContent() {
    return isEmpty(this.suggestion) ? 'Please enter a suggestion' : '';
  }

  @action
  onSubmit(e: Event) {
    e.preventDefault();

    this.args.onSubmit({
      criticism: 'New editor feedback',
      praise: this.suggestion,
    });
  }
}
